import React, { Component } from "react";
import {
  Wrapper,
  ExternalImage,
  CardBody,
  Copy,
  ContentfulRichText
} from "app/NativeComponents/common";

import { PillButton } from "app/NativeComponents/snippets";

import { openUrl, loadOnboardingText } from "app/NativeActions";

class OnboardingCopy extends Component {
  constructor(props) {
    super(props);

    this.state = {
      onboarding_content: null,
      loading: true
    };
  }

  componentDidMount() {
    loadOnboardingText("signatureInfo")
      .then(data => {
        if (data && data.items) {
          if (data.items.length > 0) {
            this.setState({
              onboarding_content: data.items[0]
                ? data.items[0].fields
                  ? data.items[0].fields
                  : null
                : null,
              loading: false
            });
          }
        }
        this.setState(() => ({ loading: false }));
      })
      .catch(err => {
        this.setState(() => ({ loading: false }));
      });
  }

  shouldComponentUpdate(prevProps, prevState) {
    if (
      prevState.onboarding_content !== this.state.onboarding_content ||
      prevState.loading !== this.state.loading
    ) {
      return true;
    }

    return false;
  }

  render() {
    const { onboarding_content, loading } = this.state;
    if (this.props.onboarding && onboarding_content && !loading) {
      return (
        <Wrapper>
          <Wrapper
            style={{
              padding: 20,
              paddingBottom: 0,
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            <ExternalImage
              style={{
                width: this.props.device == "desktop" ? "100%" : 300,
                maxWidth: 300,
                height: this.props.device == "desktop" ? "auto" : 300,
                resizeMode: "contain"
              }}
              contain
              image={onboarding_content.image.fields.file.url}
            />
          </Wrapper>
          <CardBody style={{ alignItems: "center" }}>
            <ContentfulRichText
              style={{
                textAlign: "center"
              }}
              richText={onboarding_content.richContent}
            />
            <PillButton
              onPress={() => {
                openUrl(onboarding_content.buttonLink);
              }}
              primary={true}
              innerStyle={{ padding: 5, paddingRight: 15, paddingLeft: 15 }}
              style={{ margin: 0 }}
            >
              {onboarding_content.buttonText}
            </PillButton>
          </CardBody>
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

export default OnboardingCopy;
